import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { Accessor } from "../types/types";
import { UsePropertyAccessors } from "../hooks/usePropertyAccessors";
import { UseSelectedColumns } from "../hooks/useSelectedColumns";
import { UsePropertyAggregates } from "../hooks/usePropertyAggregates";
import { Property } from "../rest/responses/Property";
import { Table } from "@tanstack/react-table";

export interface IDataTableContext
	extends Omit<UsePropertyAccessors, "loading">,
		UseSelectedColumns,
		Omit<UsePropertyAggregates, "loading"> {
	table: Table<Property>;
	isLoadingAggregates: boolean;
	isSelectColumnsModalOpen: boolean;
	setIsSelectColumnsModalOpen: Dispatch<SetStateAction<boolean>>;
	selectedIds: number[];
	displayIntegrity?: boolean;
	onBulkEdit?: (accessor: Accessor) => void;
}

const DataTableContext = createContext<IDataTableContext | null>(null);

export default DataTableContext;

export function useDataTableContext() {
	return useContext(DataTableContext);
}
